import { IconProps } from '@euler/app/components/icons/types';
import { GradientIconProps } from '@euler/app/tv/theme/types';
import { FC, memo } from 'react';
import Svg, { Defs, LinearGradient, Path, Stop } from 'react-native-svg';

export const StartTimeIcon: FC<IconProps & GradientIconProps> = memo(
  ({
    width,
    height,
    size = 16,
    color = 'rgba(255, 255, 255, 0.4)',
    startColor,
    endColor,
    style,
  }) => {
    return (
      <Svg
        width={width ?? size}
        height={height ?? size}
        viewBox="0 0 16 16"
        style={style}
      >
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5715 2.14289H14.5715C14.8875 2.14289 15.1429 2.39825 15.1429 2.71432V14.5715C15.1429 14.8875 14.8875 15.1429 14.5715 15.1429H1.42861C1.11253 15.1429 0.857178 14.8875 0.857178 14.5715V2.71432C0.857178 2.39825 1.11253 2.14289 1.42861 2.14289H4.42861V1.00003C4.42861 0.921463 4.49289 0.857178 4.57146 0.857178H5.57146C5.65003 0.857178 5.71432 0.921463 5.71432 1.00003V2.14289H10.2857V1.00003C10.2857 0.921463 10.35 0.857178 10.4286 0.857178H11.4286C11.5072 0.857178 11.5715 0.921463 11.5715 1.00003V2.14289ZM2.14289 13.8572H13.8572V7.07146H2.14289V13.8572ZM2.14289 3.42861V5.85718H13.8572V3.42861H11.5715V4.28575C11.5715 4.36432 11.5072 4.42861 11.4286 4.42861H10.4286C10.35 4.42861 10.2857 4.36432 10.2857 4.28575V3.42861H5.71432V4.28575C5.71432 4.36432 5.65003 4.42861 5.57146 4.42861H4.57146C4.49289 4.42861 4.42861 4.36432 4.42861 4.28575V3.42861H2.14289ZM5.50003 11H10.5V10H5.50003V11Z"
          fill="url(#paint0_linear_371_4133)"
        />
        <Defs>
          <LinearGradient
            id="paint0_linear_371_4133"
            x1="0.500001"
            y1="14"
            x2="15"
            y2="4"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor={startColor ?? color} />
            <Stop offset="1" stopColor={endColor ?? color} />
          </LinearGradient>
        </Defs>
      </Svg>
    );
  },
);
